import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import classNames from 'classnames'
import SwiperCore, { Navigation, Pagination, A11y } from 'swiper'
import { useJsonApi, useMobile } from 'shared'
import { TeaserProps, BlogTeaserProps, Blog } from './types'

SwiperCore.use([Navigation, Pagination, A11y])

const Teaser = ({ blog, horizontal }: TeaserProps): JSX.Element => {
  const teaserClass = classNames('generic-news-post-teaser has-small-image', {
    'is-horizontal': horizontal,
  })

  return (
    <a href={blog.href} className={teaserClass}>
      <div className="news-post-teaser-image" style={{ backgroundImage: 'url(' + blog.image + ')' }}></div>
      <div className="news-post-teaser-content">
        <h2 className="text-lg">{blog.title}</h2>
        <div className="news-post-teaser-preview" dangerouslySetInnerHTML={{ __html: blog.body }}></div>
        <div className="news-post-teaser-author">
          <i className="fas fa-user fa-fw" />
          {blog.author}
          <i className="fas fa-clock fa-fw" />
          {blog.published_at}
        </div>
      </div>
    </a>
  )
}

export const BlogTeaserList = ({ url }: BlogTeaserProps): JSX.Element | null => {
  const { data: blogList } = useJsonApi<Array<Blog>>(url)
  const desktop = !useMobile()
  if (!blogList) return null

  const slides = blogList.map((blog, index) => (
    <SwiperSlide key={index} className={desktop ? 'column flex-col' : 'swiper-slide'}>
      <Teaser blog={blog} horizontal={desktop && index === 0} />
    </SwiperSlide>
  ))

  // Do not use a Swiper if there’s nothing to swipe. Wrapping items in SwiperSlides is fine, anyways.
  if (desktop || slides.length === 1) return <>{slides}</>

  return (
    <div className="generic-teaser-swiper select-none">
      <Swiper loop pagination={{ clickable: true }} roundLengths mousewheel={{ forceToAxis: true }}>
        {slides}
      </Swiper>
    </div>
  )
}
